import { Form } from 'antd';
import styled from 'styled-components';
import CashierCalculator from './features/Calculator';
import CashierClearTicket from './features/ClearTicket';
import CashierDiscountTicket from './features/Discount';
import CashierSaveTicket from './features/SaveTicket';
import CashierVoidTicket from './features/Voided';
import CashierCardPayment from './payments/Card';
import CashierCashPayment from './payments/Cash';
import CashierEBTPayment from './payments/EBT';
import CashierEPays from './payments/EPays';
import CashierGiftCardPayment from './payments/GiftCard';
import CashierLoyaltyPayment from './payments/Loyalty';
import CashierMultiCards from './payments/MultiCards';
import CashierMultiPayment from './payments/MultiPayment';
import CashierWeight from './features/Weight';

const FooterActions = () => {
  return (
    <Container>
      <FeaturesGroup>
        <CashierCalculator />
        <Form.Item name="billId" noStyle>
          <CashierVoidTicket />
        </Form.Item>
        <Form.Item name="items" noStyle>
          <CashierClearTicket />
        </Form.Item>
        <Form.Item shouldUpdate noStyle dependencies={['subTotal']}>
          {({ getFieldValue }) => (
            <Form.Item name="discount" noStyle>
              <CashierDiscountTicket subTotal={getFieldValue('subTotal')} />
            </Form.Item>
          )}
        </Form.Item>
        <Form.List name={'items'}>
          {(_, { add }) => (<CashierWeight add={add} />)}
        </Form.List>
        <CashierSaveTicket />
      </FeaturesGroup>
      <PaymentGroup>
        <CashierEBTPayment />
        <Form.Item shouldUpdate noStyle dependencies={['cashIncentive', 'cashIncentiveAmount']}>
          {({ getFieldValue }) => (
            <CashierCashPayment
              cashIncentive={getFieldValue('cashIncentive')}
              cashIncentiveAmount={getFieldValue('cashIncentiveAmount')}
              enable={getFieldValue('cashIncentiveDiscount')}
            />)}
        </Form.Item>
        <Form.Item shouldUpdate noStyle dependencies={['chargeFee', 'feeCreditCard', 'feeCreditCardAmount']}>
          {({ getFieldValue }) => (
            <CashierCardPayment
              enableCardFee={getFieldValue('chargeFee')}
              feeCreditCard={getFieldValue('feeCreditCard')}
              feeCreditCardAmount={getFieldValue('feeCreditCardAmount')}
            />)}
        </Form.Item>
        <Form.Item shouldUpdate noStyle dependencies={['cashIncentive', 'cashIncentiveAmount', 'chargeFee']}>
          {({ getFieldValue }) => (
            <CashierMultiPayment
              discountSetting={getFieldValue('cashIncentive')}
              enableCashIncentive={getFieldValue('cashIncentiveDiscount')}
              enableCardFee={getFieldValue('chargeFee')}
            />)}
        </Form.Item>
        <Form.Item shouldUpdate noStyle dependencies={['chargeFee', 'feeCreditCard', 'feeCreditCardAmount']}>
          {({ getFieldValue }) => (
            <CashierMultiCards
              enableCardFee={getFieldValue('chargeFee')}
              feeCreditCard={getFieldValue('feeCreditCard')}
              feeCreditCardAmount={getFieldValue('feeCreditCardAmount')}
            />
          )}
        </Form.Item>

        <Form.Item shouldUpdate noStyle dependencies={['cashIncentive', 'cashIncentiveAmount']}>
          {({ getFieldValue }) => (
            <CashierEPays
              cashIncentive={getFieldValue('cashIncentive')}
              cashIncentiveAmount={getFieldValue('cashIncentiveAmount')}
              enable={getFieldValue('cashIncentiveDiscount')}
            />)}
        </Form.Item>
        <CashierGiftCardPayment />
        <Form.Item shouldUpdate noStyle dependencies={['cashIncentive', 'cashIncentiveAmount']}>
          {({ getFieldValue }) => (<CashierLoyaltyPayment customerPoint={getFieldValue('customerPoint')} />)}
        </Form.Item>

      </PaymentGroup>
    </Container>
  );
};

export default FooterActions;
const Container = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 10px;
  padding: 10px;
`;

const FeaturesGroup = styled.div`
  display: flex;
`;
const PaymentGroup = styled.div`
  display: flex;
`;
